<template>
  <ItemDialog ref="dialogRef" image-type="alert">
    <template #content-area>
      <h2>選択したポートの自転車が全て予約、利用中です</h2>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogNoCycle",
  setup() {
    const dialogRef = ref(null);

    const openDialog = () => {
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
      nativeHandlerService.returnNativeDbsWithClose();
    };

    return {
      dialogRef,
      openDialog,
      closeDialog,
    };
  },
};
</script>
